import React from 'react';
import { useTranslation } from 'react-i18next';

const Star = (props) => {
    const { t } = useTranslation();

    return (
        <div onClick={() => props.addRemoveFavorite(props.id)}
            className={`fav-icon ${props.status ? 'fav-icon--active' : ''}`}
            title={props.status ? t("fav.actionAdd") : t("fav.actionRemove")}>
            <i className="fas fa-star"></i>
        </div>
    );
};

export default Star;
